import { Action } from 'redux'
import { AreaInspection, InventoryInspection } from '../../types/inspection'
import { InventoryConfig } from '../../types/aptConfig'

export const SET_INVENTORY_INSPECTION = 'SET_INVENTORY_INSPECTION'
export const SET_INVENTORY_CONFIG = 'SET_INVENTORY_CONFIG'
export const SET_AREA_INSPECTION = 'SET_AREA_INSPECTION'

interface SetInventoryInspectionAction extends Action {
    type: typeof SET_INVENTORY_INSPECTION
    inventoryInspection?: InventoryInspection
}

interface SetInventoryConfigAction extends Action {
    type: typeof SET_INVENTORY_CONFIG
    inventoryConfig?: InventoryConfig
}

interface SetAreaInspectionAction extends Action {
    type: typeof SET_AREA_INSPECTION
    areaInspection?: AreaInspection
}

export type InspectionActionTypes =
    | SetInventoryInspectionAction
    | SetInventoryConfigAction
    | SetAreaInspectionAction
